export default function NotFound() {
  return (
    <div class="wrapper" style={{ margin: "0 auto", maxWidth: "80rem" }}>
      <h1 class="">404 Page Not Found</h1>
      <p style={{ textAlign: "center" }}>The specified file was not found on this website. Please check the URL for mistakes and try again.</p>
    </div>
  );
}